import React, { ComponentPropsWithoutRef, useState } from 'react';
import { FormFeedback, Input, InputGroup, InputGroupText, InputProps } from 'reactstrap';
import { FaEye, FaEyeSlash } from "react-icons/fa";

interface PasswordInputProps extends InputProps {
    value: string | undefined;
    errorMsg: string;
    onChange: (event: any) => void
}
const PasswordInput = ({ value, errorMsg, onChange, ...rest }: PasswordInputProps) => {
    const [passwordVisible, setPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    return (
        <InputGroup>
            <Input
                id="clientPassword"
                type={passwordVisible ? 'text' : 'password'}
                name="clientPassword"
                value={value}
                onChange={onChange}
                invalid={!!errorMsg} 
                {...rest}
            />
            <InputGroupText onClick={togglePasswordVisibility} 
                style={{ cursor: 'pointer', borderTopRightRadius: '0.375rem', borderBottomRightRadius: '0.375rem' }}>
                {passwordVisible ? <FaEyeSlash></FaEyeSlash> : <FaEye></FaEye>}
            </InputGroupText>
            <FormFeedback>{errorMsg}</FormFeedback>
        </InputGroup>
    );
};

export default PasswordInput;
